import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/pending-subscriptions/$subscriptionId/payment')({
  component: () => (
    <Navigate
      replace
      search
      from="/bak/pending-subscriptions/$subscriptionId/payment"
      to="/bo/subscriptions/$subscriptionId/payment"
    />
  ),
})
